import { LOGOUT_USER } from '../actions/types';

const INITIAL_STATE = {
  user: null
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case LOGOUT_USER:
      window.location.reload()
      return {
        ...state,
        user: ""
      };

    default:
      return {
        ...state
      };
  }
};